import React, { Dispatch, SetStateAction } from "react";

import { EmbedPreset } from "vimeo";

export interface UserContextState {
    presets?: EmbedPreset[];
}

// The argument passed to createContext simply mimics React's useState()
// semantics.
const UserContext = React.createContext<
    [UserContextState, Dispatch<SetStateAction<UserContextState>>]
>([{}, () => {}]);

export default UserContext;
